<template>
  <b-dropdown
    :triggers="['hover']"
    aria-role="list"
    position="is-bottom-left"
    style="width: 120px"
  >
    <template #trigger>
      <b-button
        :type="{
          'is-success': t.details.status === 'success',
          'is-smart-orange-7': ['refused', 'preemptivelyRefused'].includes(
            t.details.status
          ),
          'is-light': t.details.status === 'cancelled',
          'is-warning': t.details.status === 'error',
          'is-dark': t.details.status === 'refunded',
          'is-danger': t.details.status === 'chargeback',
          'is-sea': t.details.status === 'pending',
          'is-light-green':
            t.details.status === 'billingPending' ||
            t.details.status === 'chargebackPaid'
        }"
        :disabled="t.details.status === 'cancelled'"
        slot="trigger"
      >
        {{
          t.details.status === "success"
            ? "Sucesso"
            : ["refused", "preemptivelyRefused"].includes(t.details.status)
            ? "Recusada"
            : t.details.status === "error"
            ? "Erro"
            : t.details.status === "cancelled"
            ? "Cancelada"
            : t.details.status === "open"
            ? "Aberta"
            : t.details.status === "refundRequested"
            ? "Estornando"
            : t.details.status === "refunded"
            ? "Estornada"
            : t.details.status === "chargeback"
            ? "Chargeback"
            : t.details.status === "pending"
            ? "Pendente"
            : t.details.status === "billingPending"
            ? "A faturar"
            : t.details.status === "chargebackPaid"
            ? "Chargeback Pago"
            : "-"
        }}
      </b-button>
    </template>

    <div v-if="t.details.status !== 'cancelled'">
      <b-dropdown-item
        aria-role="listitem"
        v-if="t.details.status === 'error' && t.adyen && !t.adyen.response"
      >
        Sem retorno
      </b-dropdown-item>

      <b-dropdown-item
        aria-role="listitem"
        v-if="
          t.details.status === 'error' &&
          t.adyen &&
          t.adyen.response &&
          t.adyen.response.status === 422
        "
      >
        <b>Retorno: </b>
        {{ t.adyen.response.message }}
      </b-dropdown-item>

      <b-dropdown-item
        aria-role="listitem"
        v-else-if="
          t.details.status === 'refused' &&
          t.details.format === 'ecommerce' &&
          t.adyen &&
          t.adyen.response &&
          t.adyen.response.additionalData
        "
      >
        <b>Retorno: </b>
        {{ t.adyen.response.additionalData.refusalReasonRaw }}
      </b-dropdown-item>

      <b-dropdown-item
        aria-role="listitem"
        v-else-if="
          t.details.status === 'preemptivelyRefused' &&
          t.card &&
          t.card.irreversibleInfo
        "
      >
        <b>Retorno: </b>
        {{
          `${t.card.irreversibleInfo.code}: ${t.card.irreversibleInfo.message}`
        }}
      </b-dropdown-item>

      <b-dropdown-item
        aria-role="listitem"
        v-else-if="
          t.details.status === 'error' &&
          t.details.format === 'terminal' &&
          t.adyen &&
          t.adyen.response
        "
      >
        <b>Retorno: </b>
        {{
          t.adyen.response.SaleToPOIRequest
            ? t.adyen.response.SaleToPOIRequest.EventNotification.EventDetails.split(
                "="
              )[1].replace(/\+/g, " ")
            : t.adyen.response.SaleToPOIResponse &&
              t.adyen.response.SaleToPOIResponse.PaymentResponse.Response
                .AdditionalResponseObj
            ? t.adyen.response.SaleToPOIResponse.PaymentResponse.Response
                .AdditionalResponseObj.message
            : "-"
        }}
      </b-dropdown-item>

      <b-dropdown-item
        aria-role="listitem"
        v-else-if="
          t.details.status === 'refused' &&
          t.details.format === 'terminal' &&
          t.adyen &&
          t.adyen.response
        "
      >
        <b>Retorno: </b>
        {{
          t.adyen.response.SaleToPOIResponse &&
          t.adyen.response.SaleToPOIResponse.PaymentResponse.Response
            .AdditionalResponseObj
            ? t.adyen.response.SaleToPOIResponse.PaymentResponse.Response
                .AdditionalResponseObj.refusalReasonRaw ||
              t.adyen.response.SaleToPOIResponse.PaymentResponse.Response
                .AdditionalResponseObj.message
            : ""
        }}
      </b-dropdown-item>

      <b-dropdown-item
        aria-role="listitem"
        v-if="t.details.format === 'showroom'"
      >
        {{ $t("transactions.showroom") }}
        <br />
        <small>({{ $t("transactions.notCharged") }})</small>
      </b-dropdown-item>

      <b-dropdown-item v-else aria-role="listitem">
        <p>
          {{ paymentMethods }}
          {{
            t.details.origin === "vending"
              ? ""
              : t.details.format === "ecommerce"
              ? ` (${$t("transactions.app")})`
              : t.details.format === "terminal"
              ? ` (${$t("transactions.terminal")})`
              : t.details.format === "googlepay"
              ? ` (${$t("transactions.googlepay")})`
              : "?"
          }}
        </p>
      </b-dropdown-item>

      <!-- <b-modal :active.sync="isTransactionModalActive" has-modal-card>
        <transaction-modal :t="t" />
      </b-modal> -->
    </div>
  </b-dropdown>
</template>

<script>
import { mask } from "../../../mixins/mask";

export default {
  mixins: [mask],

  props: ["t"],

  computed: {
    paymentMethods() {
      let p = [];

      if (this.t.discounts.coupon) {
        p.push(this.$t("transactions.coupon"));
      }

      if (this.t.discounts.cashbackUsed) {
        p.push(this.$t("transactions.cashback"));
      }

      if (this.t.details.prepaid) {
        p.push(this.$t("transactions.prepaid"));
      }

      if (this.t.details.fundingSource === "credit") {
        p.push(this.$t("transactions.credit"));
      }

      if (this.t.details.fundingSource === "debit") {
        p.push(this.$t("transactions.debit"));
      }

      if (this.t.details.fundingSource === "pix") {
        p.push(this.$t("transactions.pix"));
      }

      if (this.t.details.paymentMethod === "mbway") {
        p.push(this.$t("transactions.mbway"));
      }

      if (this.t.details.fundingSource === "voucher") {
        p.push(this.$t("transactions.voucher"));
      }

      return p.join(" + ");
    }
  }
};
</script>

<style scoped>
.separator {
  height: 1px;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.bill-separator {
  height: 1px;
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
}
</style>
